import * as yup from 'yup';

export const ForgotPasswordFormValidationSchema = yup.object({
  username: yup
    .string()
    .email('Email must be a valid email')
    .required('Email is a required field')
});

export type ForgotPasswordFormValues = yup.InferType<
  typeof ForgotPasswordFormValidationSchema
>;
